module.exports = __webpack_public_path__ + "static/media/pomona-logo.3161ffec.svg";